import APP_CONSTANTS from "../constants";

export function formatPhoneNo(phone) {
  if (phone !== undefined && phone !== null && phone !== "") {
    let ph = phone
      .trim()
      .split(" ")
      .join("");
    return ph.slice(0, 4) + " " + ph.slice(4, 7) + " " + ph.slice(7, 10);
  } else {
    return "";
  }
}

export function capitaliseFirstLetter(str) {
  return str.replace(/^\w/, c => c.toUpperCase());
}

export function formatMedicareNo(num) {
  if (num !== undefined && num !== null && num !== "") {
    let ph = num
      .trim()
      .split(" ")
      .join("");
    return ph.slice(0, 4) + " " + ph.slice(4, 9) + " " + ph.slice(9, 10);
  } else {
    return "";
  }
}

export function getDoctorInfoMapped(doctor) {
  let name = "UIN: " + doctor.doctorId + " | " + doctor.firstName.trim() + " ";

  if (doctor.middleName && doctor.middleName.trim().length > 0) {
    name = name + doctor.middleName + " ";
  }

  name = name + doctor.lastName;

  return name;
}

// return patient info for table in on string
export function getPatientInfoMapped(patient) {
  return (
    "UIN: " +
    patient.patientId +
    " | " +
    patient.firstName +
    " " +
    patient.lastName
  );
}


export const getSuffixOfNumber = (number) => {
  let divisionByTen = number % 10,
    devisionByHundred = number % 100;
  if (divisionByTen == 1 && devisionByHundred != 11) {
    return number + 'st';
  }
  if (divisionByTen == 2 && devisionByHundred != 12) {
    return number + 'nd';
  }
  if (divisionByTen == 3 && devisionByHundred != 13) {
    return number + 'rd';
  }
  return number + 'th';
};

export function openUIN(patientData, token) {
  window.open(
    APP_CONSTANTS.pmsURL +
    "/patient/patientDetails?accessToken=" +
    token +
    "&patientId=" +
    patientData._id +
    "&searchType=DOCTOR" +
    "&adminName=" +
    patientData.firstName +
    " " +
    patientData.lastName,
    "_blank"
  );
}

export const getAddressInOneLine = (patientAddressObj) => {
  let address = '';
  if (patientAddressObj.unitNumber) {
    address = address + patientAddressObj.unitNumber + '/';
  }

  if (patientAddressObj.streetNumber) {
    address = address + patientAddressObj.streetNumber + ' ';
  }

  if (patientAddressObj.streetName) {
    address = address + patientAddressObj.streetName + ' ';
  }

  if (patientAddressObj.suburb) {
    address = address + patientAddressObj.suburb.toUpperCase() + ' ';
  }

  if (patientAddressObj.state) {
    address = address + patientAddressObj.state + ' ';
  }

  if (patientAddressObj.postCode) {
    address = address + patientAddressObj.postCode;
  }
  return address;
}

export const copyText = async (text) => {
  let isCopied = false;
  if (navigator.clipboard) {
    // Modern asynchronous clipboard API
    try {
      const copied = await navigator.clipboard.writeText(text);
      isCopied = true;
    } catch (e) {
      console.log("Error during copy: ", e);
    }

  } else {
    // Fallback for older browsers
    var textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      isCopied = true;
      console.log("Copied 2");
    } catch (err) {
      console.log("Error during copy 2: ", err);
    }
    document.body.removeChild(textArea);
  }
  return isCopied;
}

export const formatIHINumberForDisplay = (ihiNumber) => {
  let ihi = '';
  if (ihiNumber) {
    let removedSpaces = ihiNumber.replace(/\r?\n/g, "");
    if (removedSpaces.length === 16) {
      ihi = removedSpaces.substr(0, 4) + ' ' + removedSpaces.substr(4, 4) + ' ' + removedSpaces.substr(8, 4) + ' ' + removedSpaces.substr(12, 4);
    } else {
      ihi = removedSpaces;
    }
  }
  return ihi;
}

export  function doctorInSchedule(doctor, scheduleFilterElement) {
  if (scheduleFilterElement.title === "Instant Leaf" && doctor.isAccessToInstantSwitchMC) {
    return true;
  }

  if (scheduleFilterElement.title === "Instant Switch" && doctor.isAccessToInstantSwitch) {
    return true;
  }

  return !!(scheduleFilterElement.title === "Instant Hush" && doctor.isAccessToInstantHush);
}

